import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { CalculatePlanningPopup } from './CalculatePlanningTable';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import moment from 'moment';
import { decryptAES } from '../../../utils/Encryption';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class CalculatePlanning extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        //this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isLoading: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            materialObject: {
                idMaterialPlanning_Multiple: 0,
                updateStatus: 0,
                idCustomer: 0,
                CustomerList: [],
                idWorkOrder: 0,
                workOrderList: [],
                idProduct: 0,
                productList: [],
                planingQuantity: '',
            },
            dtMaterialPlanning: [],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                idCustomer: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
                idWorkOrder: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "work order"
                        ),
                    },
                ],
                idProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            this.resetFields();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.usp_Transaction_MaterialPlanning_MultipleSelectByID(event.data.idMaterialPlanning_Multiple);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, }, () => {
            this.resetFields();
        });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.materialObject;
        details[name] = event.value;
        this.setState({ materialObject: details }, () => {
            if (name === 'idCustomer') {
                this.usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2();
            }
            // else if (name === 'idWorkOrder') {
            //     this.usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning();
            // } else if (name === 'idProduct') {
            //     this.usp_Transaction_WorkOrderProductsSelect();
            // }
        });
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelectCustomerForCalculatePlanning()
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Calculate Planning Data",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            pinned: [""].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialPlanning", "sR.No"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Calculate Planing Data",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            //this.procSelectAllRecord2GridviewSP(id, "Calculate Planing Data");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "idMaterialPlanning_Multiple": window.innerWidth * 0.06,
            "planningDate": window.innerWidth * 0.07,
            "woRecvNo": window.innerWidth * 0.05,
            "customer": window.innerWidth * 0.25,
            "woRecvDate": window.innerWidth * 0.07,
            "deliveryDate": window.innerWidth * 0.07,
            "piStatus": window.innerWidth * 0.05,
            "wpStatus": window.innerWidth * 0.05,
            "closeStatus": window.innerWidth * 0.05,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "jobWorkNo": window.innerWidth * 0.05,
            // "jobWorkDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "vendor": window.innerWidth * 0.15,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelectCustomerForCalculatePlanning = () => {
        this.transactionStockServices.usp_Master_PartyAccountSelectCustomerForCalculatePlanning(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));
                    let obj = this.state.materialObject;
                    obj.CustomerList = dynamicData;
                    this.setState({ materialObject: obj }, () => {
                        //this.getMasterAccountHeadSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    //this.getMasterAccountHeadSelect();
                }
            }
        });
    }


    usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2 = () => {
        let request = [
            this.state.materialObject.idCustomer,
            this.state.materialObject.idMaterialPlanning_Multiple,
            this.state.materialObject.updateStatus,
            this.state.materialObject.idMaterialPlanning_Multiple    //idSalesInvoice,
        ];
        this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idwoOrderRecv,
                        label: x.woRecvNo + " - " + x.priority,
                    }));
                    let obj = this.state.materialObject;
                    obj.workOrderList = dynamicData;
                    obj.idWorkOrder = obj.idWorkOrder;
                    this.setState({ materialObject: obj });
                }
            }
        });
    }

    click_AddBomData = async () => {
        if (this.state.materialObject.idWorkOrder > 0) {
            await this.addWoBomData();
            //await this.modifyQty();
        }
    }

    addWoBomData = async () => {
        let request = [this.state.materialObject.idWorkOrder, this.state.idCompany];
        this.setState({ isLoading: true });
        let response = await this.transactionStockServices.usp_Transaction_MaterialPlanningSelectbyId(request);
        if (response.statusCode === 200 && response.responseItem !== null) {
            let handleRes = response.responseItem.responseContent[0];
            let _dtMaterialPlanning = [];

            for (const dr of handleRes) {
                let datarow = {
                    idItem: dr.idItem,
                    drawingNo: dr.drawingNo,
                    // itemType: dr.itemType, // optional
                    itemName: dr.itemName,
                    minimumStock: dr.minimumStock,
                    mrsQty: dr.mrsQty,
                    inquiryQty: dr.inquiryQty,
                    poQty: dr.poQty,
                    qcQty: dr.qcQty,
                    storeQty: dr.storeQty,
                    workPlanningQty: dr.workPlanningQty,
                    rejectQty: dr.rejectQty,
                    issueQty: dr.issueQty,
                    occupyQuantity: dr.occupyQuantity,
                    requiredQuantity: dr.requiredQty,
                    totalRequiredQuantity: dr.totalRequiredQty,
                    piQuantity: 0,
                    mrsQuantity: 0
                };

                let finalqty = Number(dr.totalRequiredQty);
                let store = Number(dr.storeQty);
                let occupyQuantity = Number(dr.occupyQuantity);
                let min = Number(dr.minimumStock);
                let poQty = Number(dr.poQty);

                if (finalqty > occupyQuantity) {
                    datarow.piQuantity = (min + finalqty) - occupyQuantity - poQty;
                    datarow.mrsQuantity = 0;
                }

                if (finalqty < occupyQuantity + poQty) {
                    datarow.mrsQuantity = finalqty;
                    if (occupyQuantity < min) {
                        let minimum = min - occupyQuantity;
                        datarow.piQuantity = Number(minimum.toFixed(1));
                    } else {
                        datarow.piQuantity = 0;
                    }
                }

                _dtMaterialPlanning.push(datarow);
                this.setState({ isLoading: false });
            }

            this.setState({ dtMaterialPlanning: _dtMaterialPlanning });
        } else {
            this.setState({ isLoading: false });
        }
    };

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        if (this.state.dtMaterialPlanning.length === 0) {
            this.SwalServices.Alert("Please add items details");
        } else {
            let data = this.state.materialObject;
            let dtMaterialPlanning = this.state.dtMaterialPlanning;
            let request = {

                idMaterialPlanning_Multiple: data.idMaterialPlanning_Multiple,
                date: new Date().toISOString(),
                idCustomer: data.idCustomer,
                idWOOrderRecv: data.idWorkOrder,
                idCompany: this.state.idCompany,
                e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                isUpdated: data.updateStatus === 1 ? true : false,
                updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                isDeleted: false,
                deletedDate: null,
                d_IDUser: null,
                // idItem: null,
                // isClose: null,
                // closeDate: null,
                // planningQty: null,
                // actualItemID: null,
                // isPlanningClosed: null,
                // planningClosedDate: null,
                // isPIClosed: null,
                // piClosedDate: null,
                idFinancialYear: null,
            };
            request.itemList = [];
            this.state.dtMaterialPlanning.map((x) => {
                let obj = {
                    idMaterialPlanning: data.idMaterialPlanning,
                    idItem: x.idItem || 0,
                    idWOOrderRecvItems: x.idWOOrderRecvItems || 0,
                    idWOOrderRecv: data.idWorkOrder,
                    mrsQty: x.mrsQty || 0,
                    piQty: x.inquiryQty || 0,
                    poQty: x.poQty || 0,
                    qcQty: x.qcQty || 0,
                    storeQty: x.storeQty || 0,
                    rejectQty: x.rejectQty || 0,
                    issueQty: x.issueQty || 0,
                    workPlanningQty: x.workPlanningQty || 0,
                    requiredQuantity: x.requiredQuantity || 0,
                    totalRequiredQuantity: x.totalRequiredQuantity || 0,
                    mrsQuantity: x.mrsQuantity || 0,
                    piQuantity: x.piQuantity || 0,
                    occQty: x.occupyQuantity || 0,
                    isParent: x.isParent || 0,
                    isChild: x.isChild || 0,
                    parentId: x.parentId || 0,
                    minimumStock: x.minimumStock || 0
                };
                request.itemList.push(obj);
            });
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.transactionStockServices.usp_Transaction_MaterialPlanning_MultipleInsertUpdate(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    if (data !== null) {
                        if (this.state.materialObject.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.setState({
                                isModalOpen: false,
                                //receiptDetails: reset
                            }, () => {
                                this.resetFields();
                                this.procSelectAllRecordsSP();
                                this.usp_Master_PartyAccountSelectCustomerForCalculatePlanning()
                            });
                        }
                    }
                }
            }).finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
        }
        //}
    }

    resetFields = () => {
        let data = this.state.materialObject;
        data.idMaterialPlanning = 0;
        data.updateStatus = 0;
        data.idCustomer = 0;
        //data.CustomerList = [];
        data.idWorkOrder = 0;
        data.workOrderList = [];
        data.idProduct = 0;
        data.productList = [];
        data.planingQuantity = '';
        this.setState({ materialObject: data, dtMaterialPlanning: [] });
    }

    clear = () => {
        let data = this.state.materialObject;
        data.updateStatus = 0;
        data.idCustomer = 0;
        data.idWorkOrder = 0;
        data.workOrderList = [];
        data.idProduct = 0;
        data.productList = [];
        data.planingQuantity = '';
        this.setState({ materialObject: data, dtMaterialPlanning: [] });
    }

    usp_Transaction_MaterialPlanning_MultipleSelectByID = async (id) => {
        let response = await this.transactionStockServices
            .usp_Transaction_MaterialPlanning_MultipleSelectByID(id);

        if (response.statusCode === 200 && response.responseItem !== null) {
            let ds = response.responseItem.responseContent;

            // Table[1] -> Material Planning Rows
            let dt = ds[1] || [];
            let _dtMaterialPlanning = [];

            dt.forEach(dr => {
                let datarow = {
                    idItem: dr.idItem,
                    drawingNo: dr.drawingNo,
                    itemType: dr.itemType,
                    itemName: dr.itemName,

                    mrsQty: dr.mrsQty,
                    inquiryQty: dr.piQty,
                    poQty: dr.poQty,
                    qcQty: dr.qcQty,
                    storeQty: dr.storeQty,
                    rejectQty: dr.rejectQty,
                    issueQty: dr.issueQty,

                    requiredQuantity: dr.requiredQuantity,
                    totalRequiredQuantity: dr.totalRequiredQuantity,
                    piQuantity: dr.piQuantity,
                    mrsQuantity: dr.mrsQuantity,
                    occupyQuantity: dr.occQty,

                    workPlanningQty: dr.workPlanningQty,
                    isParent: dr.isParent,
                    isChild: dr.isChild,
                    parentId: dr.parentId,

                    minimumStock: dr.minimumStock
                };

                _dtMaterialPlanning.push(datarow);
            });

            let headerTable = ds[0] || [];
            let customerId = 0;
            let workOrderId = 0;
            let materialObject = this.state.materialObject;
            if (headerTable.length > 0) {
                let dr1 = headerTable[0];
                customerId = Number(dr1.idCustomer);
                workOrderId = dr1.idwoOrderRecv ? Number(dr1.idwoOrderRecv) : 0;

                // Example: update dropdowns in state
                materialObject.idMaterialPlanning_Multiple = Number(dr1.idMaterialPlanning_Multiple);;
                materialObject.idCustomer = customerId;
                materialObject.idWorkOrder = workOrderId;
                materialObject.updateStatus = 1;
                this.setState({
                    materialObject: materialObject
                }, () => {
                    this.usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2();
                });

                // Optional: Enable/Disable buttons like in C#
                // let btnSaveEnabled = !(dr1.piStatus === "YES" || dr1.wpStatus === "YES");
            }

            // Save dtMaterialPlanning in state
            this.setState({ dtMaterialPlanning: _dtMaterialPlanning, isModalOpen: true });
        }
    };

    render() {
        return (
            <div className='calculate-planing'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <CalculatePlanningPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            handleChange={this.handleChange.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            dtMaterialPlanning={this.state.dtMaterialPlanning}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            click_AddBomData={this.click_AddBomData.bind(this)}
                            clear={this.clear.bind(this)}
                            isLoading={this.state.isLoading}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Calculate planing data</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
